import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import ReactMarkDown from 'react-markdown';

import html from 'remark-html';
import { remark } from 'remark';

import remarkCustomheaderId from 'remark-custom-header-id';
import remarkSuperSub from 'remark-supersub';
import rehypeRaw from 'rehype-raw';
import remarkGFM from 'remark-gfm';
import remarkDefList from 'remark-deflist';
import { size } from '@marriott/mi-ui-library';
import { StyledMarkDown } from './MarkDown.styles';

async function isMarkDownText(text: string) {
  const regex = /==(.+?)==/g;
  if (text?.match(regex)?.length) return true;
  try {
    const output = await remark().use(remarkGFM).use(remarkDefList).use(html).process(text);
    // even after removing the p tags if the text is same then its normal text
    return (
      String(text)?.trim() !==
      String(output?.value)
        ?.trim()
        ?.replaceAll(/^(<p>)|(<\/p>)$/g, '')
        .trim()
    );
  } catch (e) {
    return false;
  }
}

export const MarkDownText = (props: {
  className: string;
  textContent: string;
  fallback: React.ReactElement;
  variation: string;
  fontSize?: size;
}) => {
  const { className, textContent, fallback, variation, fontSize = size.medium } = props;
  const [isMarkDown, setIsMarkDown] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const transformHighlighSection = (text: string | null | undefined) => {
    const regex = /==(.+?)==/g;
    const highlightParts = text ? [...text.matchAll(regex)] : [];
    let transformedText = text;
    highlightParts?.forEach(item => {
      transformedText = transformedText?.replace(item?.[0], `<mark>${item?.[1]}</mark>`);
    });
    return transformedText;
  };

  useEffect(() => {
    if (textContent) {
      isMarkDownText(textContent)
        ?.then(response => {
          setIsMarkDown(response);
          setIsLoaded(true);
        })
        .catch(err => {
          console.log(err);
          setIsLoaded(true);
        });
    }
  }, [textContent]);

  return (
    <div className={clsx({ 'invisible ': !isLoaded })}>
      {isMarkDown ? (
        <StyledMarkDown className={clsx('markdown-text', `t-${variation}-${fontSize}`, className)}>
          <ReactMarkDown
            remarkPlugins={[
              textContent?.includes('~') && !textContent?.includes('~~') ? remarkSuperSub : remarkGFM,
              remarkCustomheaderId,
              remarkDefList,
            ]}
            rehypePlugins={[rehypeRaw]}
          >
            {transformHighlighSection(textContent)}
          </ReactMarkDown>
        </StyledMarkDown>
      ) : (
        fallback
      )}
    </div>
  );
};
